import { UserRole } from "../types/Irmao"
import { IUser } from "../types/User"
import { intersects } from "./utils"

export const intersectRoles = (roleA?: UserRole | UserRole[] | null, roleB?: UserRole | UserRole[] | null) =>
	roleA === roleB ||
	(typeof roleA === 'string' && Array.isArray(roleB) && roleB.includes(roleA)) ||
	(typeof roleB === 'string' && Array.isArray(roleA) && roleA.includes(roleB)) ||
	(Array.isArray(roleA) && Array.isArray(roleB) && intersects(roleA, roleB))

const ROLES_DE_VISITANTE: UserRole[] = ['Visitante', 'limitado']

export const éRoleDeVisitante = (role?: UserRole | UserRole[] | null): boolean =>
	!!role && intersectRoles(ROLES_DE_VISITANTE, role)

export const éVisitante = (user?: IUser | null): boolean => éRoleDeVisitante(user?.role)
